"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrandLogoBrands = exports.BrandLogo = void 0;
var _logoModule = _interopRequireDefault(require("@albelli/arc-3/lib/logo.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const BrandLogoBrands = exports.BrandLogoBrands = ["albelli", "bonusprint", "fotoknudsen", "minnebanken", "onskefoto", "monalbumphoto", "posterxxl", "posterxxl-b2b", "hofmann", "photobox"];
const BrandLogo = _ref => {
  let {
    vendor,
    href,
    brand,
    white,
    small,
    ...props
  } = _ref;
  const brandLookup = vendor => {
    const brand = BrandLogoBrands.find(i => vendor.toLowerCase().includes(i));
    return brand ? brand : BrandLogoBrands[0];
  };
  let isB2bBrand = false;
  if (!!vendor && !brand) {
    brand = brandLookup(vendor);
    isB2bBrand = vendor.toLowerCase().includes("b2b");
  }
  const brandLogoClass = "arc3-logo-".concat(brand + (isB2bBrand ? "-b2b" : ""));
  const classes = (0, _classnames.default)(_logoModule.default[brandLogoClass], {
    [_logoModule.default["white"]]: white,
    [_logoModule.default["small"]]: small
  });
  return /*#__PURE__*/_react.default.createElement("a", _extends({
    "data-cy": "arc3-brandlogo",
    href: href
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }));
};
exports.BrandLogo = BrandLogo;